var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretUpdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "11 8 7.532 13.175"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.119 13.647h-6.71c-.37 0-.515-.471-.327-.732L14.42 8.23c.19-.26.5-.326.69-.065l3.337 4.782c.19.26.044.7-.327.7m-6.706 1.882h6.708c.372 0 .516.471.328.732l-3.337 4.684c-.19.259-.5.325-.69.064l-3.337-4.781c-.19-.26-.044-.699.328-.699"
})));
export default SvgCaretUpdown;